// Shared Tailwind class builders for the Foydali tools, so ten separate tools
// still look like one panel in both themes.

export const fieldClass = (isDarkMode) => `w-full px-3 py-2 rounded-lg border outline-none transition-colors ${isDarkMode
  ? 'bg-dark/60 border-primary/20 text-light placeholder-light/30 focus:border-primary'
  : 'bg-white border-gray-200 text-gray-800 placeholder-gray-400 focus:border-green-500'}`;

export const buttonClass = (isDarkMode, variant = 'secondary') => {
  const base = 'px-4 py-2 rounded-lg font-medium text-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed';
  if (variant === 'primary') {
    return `${base} ${isDarkMode
      ? 'bg-primary text-dark hover:bg-secondary'
      : 'bg-green-600 text-white hover:bg-green-700'}`;
  }
  return `${base} ${isDarkMode
    ? 'bg-dark/60 text-light/80 border border-primary/20 hover:text-primary hover:border-primary/40'
    : 'bg-gray-100 text-gray-700 border border-gray-200 hover:bg-gray-200'}`;
};

export const tabClass = (isDarkMode, active) => `px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${active
  ? isDarkMode ? 'bg-primary text-dark' : 'bg-green-600 text-white'
  : isDarkMode
    ? 'bg-dark/50 text-light/60 border border-primary/20 hover:text-primary'
    : 'bg-gray-100 text-gray-600 border border-gray-200 hover:bg-gray-200'}`;

export const labelClass = (isDarkMode) => `block text-xs font-medium mb-1.5 ${isDarkMode ? 'text-light/60' : 'text-gray-500'}`;

export const panelClass = (isDarkMode) => `rounded-xl p-4 ${isDarkMode ? 'bg-dark/40 border border-primary/10' : 'bg-gray-50 border border-gray-100'}`;

export const resultClass = (isDarkMode) => `text-2xl font-bold break-all ${isDarkMode ? 'text-primary' : 'text-green-600'}`;

export const mutedClass = (isDarkMode) => (isDarkMode ? 'text-light/50' : 'text-gray-500');
